"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NotePopup = void 0;
const tslib_1 = require("tslib");
const throttle_1 = tslib_1.__importDefault(require("lodash/throttle"));
const React = tslib_1.__importStar(require("react"));
const react_redux_1 = require("react-redux");
const rebass_1 = require("rebass");
const Textarea_1 = tslib_1.__importDefault(require("../../components/Textarea"));
const NotesRedux_1 = require("../../Redux/ActionsReducers/NotesRedux");
const SystemRedux_1 = require("../../Redux/ActionsReducers/SystemRedux");
const AdaptableContext_1 = require("../AdaptableContext");
const CellPopup_1 = require("../Components/CellPopup");
const NoteEditor = ({ note, onNoteChange, onClose, editMode, isReadonly }) => {
    const textAreaRef = React.useRef(null);
    const [liveValue, setLiveValue] = React.useState(note || '');
    const throttledOnChange = React.useMemo(() => {
        const throttled = (0, throttle_1.default)((value) => onNoteChange(value), 300);
        return (value) => {
            setLiveValue(value);
            throttled(value);
        };
    }, []);
    React.useEffect(() => {
        var _a;
        if (editMode) {
            (_a = textAreaRef.current) === null || _a === void 0 ? void 0 : _a.focus();
        }
    }, [editMode]);
    return (React.createElement(Textarea_1.default, { readOnly: isReadonly, ref: textAreaRef, width: "100%", minWidth: 180, minHeight: 120, value: liveValue, onBlur: () => onClose(), onKeyDown: (event) => {
            if (event.key === 'Escape') {
                onClose();
            }
        }, onChange: (event) => throttledOnChange(event.target.value) }));
};
const NotePopup = () => {
    var _a;
    const { api } = (0, AdaptableContext_1.useAdaptable)();
    const cellPopupRef = React.useRef(null);
    const editMode = (0, react_redux_1.useSelector)((state) => (0, SystemRedux_1.SystemNotesEditModeSelector)(state.System));
    const noteGridCell = (0, react_redux_1.useSelector)((state) => (0, SystemRedux_1.SystemNotesSelector)(state.System));
    const [
    // Only handle first note for now
    // Later we can handle multiple notes
    note,] = (0, react_redux_1.useSelector)((state) => {
        return noteGridCell ? (0, NotesRedux_1.GetNotesSelector)(state.Notes, noteGridCell) : [];
    });
    const handleNoteChange = (value) => {
        api.notesApi.updateNoteText(value, note);
    };
    const isReadonly = api.entitlementApi.isModuleReadOnlyEntitlement('Notes');
    const enableEditMode = () => {
        if (!editMode) {
            api.notesApi.showNotes(noteGridCell, true);
            cellPopupRef === null || cellPopupRef === void 0 ? void 0 : cellPopupRef.current.refreshContent();
        }
    };
    if (!noteGridCell) {
        return React.createElement(React.Fragment, null);
    }
    return (React.createElement(CellPopup_1.CellPopup, { ref: cellPopupRef, key: `${noteGridCell.PrimaryKeyValue}-${noteGridCell.ColumnId}`, isOpen: true, primaryKeyValue: noteGridCell.PrimaryKeyValue, columnId: noteGridCell.ColumnId },
        React.createElement(rebass_1.Flex, { onClick: () => enableEditMode(), flexDirection: "column", className: "ab-NotesPopup" },
            React.createElement(NoteEditor, { isReadonly: isReadonly, editMode: editMode, key: note === null || note === void 0 ? void 0 : note.Uuid, onClose: () => api.notesApi.hideNote(), note: (_a = note === null || note === void 0 ? void 0 : note.Value) !== null && _a !== void 0 ? _a : '', onNoteChange: (value) => handleNoteChange(value) }))));
};
exports.NotePopup = NotePopup;
